module.exports = __webpack_public_path__ + "img/wonder-white-logo.6d5b906a.webp";